import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import ServiceCodeModal from './ServiceCodeModal';
import { deleteServiceCode, getMasterData, getServiceCodeBySearchText, getServiceCodeList } from '../actions/ServiceCodeActions';
import Alert from 'react-s-alert';
import Paginator from '../../../../../components/paginationCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../components/reduxFields';
import SubString from 'add-ellipsis';
import Sorting from '../../../../../components/SortingCustom';
import GlobalVariables, { resetFiltersAndSorting, showNormalizedRate, alertConfirmation } from '../../../../../actions/utilAction';
import Tooltip from '../../../../../components/Tooltip';


class ServiceCodeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      // serviceCodes: [],
      // includedData: [],
      serviceCodeData: null,
      serviceCodeId: null,
      // meta_data: null,
    };

    this.filter = {
      sortColumn: '',
      sortOrder: '', 
      searchText: '',
    };

    this.handleSearchServiceCode = this.handleSearchServiceCode.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  }

  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sortColumn ? this.filter.sortColumn : '',
      sort_order: this.filter.sortOrder ? this.filter.sortOrder : '',
      contain_filters: { searchText: this.filter.searchText ? this.filter.searchText : undefined },
      pageNumber: page_number ? page_number : 1,    
      pageSize: GlobalVariables.PageSize,  
    };
    
    this.props.getServiceCodeList(searchObj);
  }

  componentWillMount() {
    // console.log(this.props);
    this.props.getMasterData();
    this.loadData();
  }

  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, serviceCodeData: null, serviceCodeId: null });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.dispatch(reset('ServiceCodeListForm'));
    this.filter.searchText = '';
  };

  handleEditClick = (event, obj) => {
    Alert.closeAll(); 
    this.setState({ open: true, serviceCodeData: obj, serviceCodeId: obj.id });
  }

  handleAlertClick = (event, id) => {

    this.props.deleteServiceCode(id);
    Alert.closeAll();
  }
  componentWillUnmount() {
    Alert.closeAll();
  }
  handleDeleteClick = (event, obj) => {
    alertConfirmation('Once you click yes, all the appointments and clients linked with this service code will get effected. Are you sure you want to delete this service code ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  }

  handleSearchServiceCode(event) {
    // event.preventDefault();
    // console.log('ServiceCode............',event.ServiceCode);

    // if (event.ServiceCode != undefined) {

    //   this.filter.searchText = event.ServiceCode;
    //   let searchObj = {
    //     sort_fields: this.filter.sort_Column ? this.filter.sort_Column : '-id',
    //     contain_filters: { serviceCode: this.filter.searchText },
    //     page_number: 1,
    //     includes: 'include=masterunittype,masterroundingrules',
    //   };

    //   this.props.getServiceCodeBySearchText(searchObj);
    // } else {
    //   this.filter.searchText = '';
    //   this.loadData();
    // }
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('ServiceCodeListForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.loadData();
  }

  setSortColumn(sortColumn, sortOrder) {
    if (sortColumn) {
      this.filter.sortColumn = sortColumn;
      this.filter.sortOrder = sortOrder;
      this.loadData();
    }
  }

  renderData() {
    return this.props.serviceCodes.data.map((Obj, index) => {
     // let data = Obj.attributes;
      return (
        <tr key={index}>
          <td>{Obj.serviceCode}</td>
          <td>
            {Obj.description && Obj.description.length > 0 ?
              <Tooltip Description={Obj.description} />
              : null}
            {Obj.description != null && Obj.description.length > 25 ? SubString(Obj.description, 25) : Obj.description != null ? Obj.description : 'N/A'}
          </td>
          <td>{`${Obj.unitDuration} ${Obj.unitTypeName}`}</td>
          <td>{showNormalizedRate(Obj.ratePerUnit)}</td>
          <td className={Obj.isBillable === true ? 'greenfont' : 'redfont'}>{Obj.isBillable ? 'Yes' : 'No'}</td>
          <td className={Obj.isRequiredAuthorization === true ? 'greenfont' : 'redfont'}>{Obj.isRequiredAuthorization ? 'Yes' : 'No'}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }


  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });

    return (
      <div>
        <h2 className="page_title">Manage Service Code</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  {this.props.addPermission ?
                    <RaisedButton label="Add Service Code" primary={true} onTouchTap={this.handleOpen} />
                    : null
                  }
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchServiceCode)}>
                        <Field
                          name="ServiceCode"
                          floatingLabelText="Search"
                          maxLength='10'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton onTouchTap={this.handleResetButton} className="grey_btn">Reset</RaisedButton>

                    </div>
                  </div>
                </div>
              </div>
              {this.state.open ? <ServiceCodeModal serviceCodeData={this.state.serviceCodeData} serviceCodeId={this.state.serviceCodeId} closeDialog={this.handleClose} /> : null}
            </div>
            <div className="row">
              <div className="col-sm-12">

                <div className="table-responsive mt-15">

                  {this.props.serviceCodes.data ? this.props.serviceCodes.data.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="13%"><Sorting setSortColumn={this.setSortColumn} columnName='serviceCode' displayName='Service Code' /></th>
                          <th width="24%"><Sorting setSortColumn={this.setSortColumn} columnName='description' displayName='Description' /></th>
                          <th width="13%"><Sorting setSortColumn={this.setSortColumn} columnName='unitDuration' displayName='Unit Duration' /></th>
                          <th width="15%"><Sorting setSortColumn={this.setSortColumn} columnName='ratePerUnit' displayName='Rate Per Unit($)' /></th>
                          <th width="10%"><Sorting setSortColumn={this.setSortColumn} columnName='isBillable' displayName='Billable' /></th>
                          <th width="15%"><Sorting setSortColumn={this.setSortColumn} columnName='isRequiredAuthorization' displayName='Rqd. Authorization' /></th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="10%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="15%"><span>Service Code</span></th>
                          <th width="20%"><span>Description</span></th>
                          <th width="15%"><span>Unit Duration</span></th>
                          <th width="15%"><span>Rate Per Unit($)</span></th>
                          <th width="10%"><span>Billable</span></th>
                          <th width="15%"><span>Required Authorization</span></th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="10%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="7">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    : null}

                </div>
                {this.props.serviceCodes.meta && this.props.serviceCodes.meta['totalPages'] && this.props.serviceCodes.meta['totalPages'] > 1 ?
                  <Paginator data={this.props.serviceCodes.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                  : null}
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}


ServiceCodeList = reduxForm({
  form: 'ServiceCodeListForm',
})(ServiceCodeList);

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "MASTERS");
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "MASTERS_SERVICECODES_LIST" && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_SERVICECODES_LIST_ADD")[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_SERVICECODES_LIST_UPDATE")[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "MASTERS_SERVICECODES_LIST_DELETE")[0].permission : false;

  // End For Role Permission

  // console.log('state.service_code.serviceCodes..................',state.service_code.serviceCodes);
  return {
    // master_data: state.service_code.master_data,
    serviceCodes: state.service_code.serviceCodes,
    serviceCodeData: state.service_code.serviceCodeData,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission
  };
}


export default connect(mapStateToProps, { getMasterData, getServiceCodeBySearchText, getServiceCodeList, deleteServiceCode })(ServiceCodeList);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/serviceCode/components/index.js